import React, { useEffect, useState } from "react";
import { FlowParts } from "../Parts/flowParts";
import { ButtonTemplate } from "../Templates/buttonTemplates";
import { ButtonParts } from "../Parts/buttonParts";
import { QuestionA1Parts } from "../Parts/qualification/questionA1Parts";
import { QuestionA2Parts } from "../Parts/qualification/questionA2Parts";
import { QuestionA3Parts } from "../Parts/qualification/questionA3Parts";
import { QuestionB1Parts } from "../Parts/qualification/questionB1Parts";
import { QuestionB2Parts } from "../Parts/qualification/questionB2Parts";
import { QuestionB3Parts } from "../Parts/qualification/questionB3Parts";
import { QualificationNg } from "../Parts/qualification/qualificationNgParts";


export const QualificationView = (props) => {

    const [questionType, setQuestionType] = useState(props.defaultValue.questionType)
    const [ questionCheck, setQuestionCheck ] = useState(props.defaultValue.questionCheck)

    useEffect(() => {
        window.scrollTo(0,0)
    },[questionType, questionCheck])

    const questionTypeChage = () => {

        if(questionType === 0){
            setQuestionType(1)
            setQuestionCheck(0)
        }else if(questionType === 1){
            setQuestionType(2)
            setQuestionCheck(0)
        }else if(questionType === 2){
            setQuestionType(3)
            setQuestionCheck(0)
        }else{
           
        }
    }

    
    const nextFlow = () => {
        props.setQuestionAndNextFlow(questionType, questionCheck)
      
    }

    return (
        <div className="select">
            {
                 questionType === 0 &&
                 <>
                 {
                    questionCheck === 0 && 
                    <>
                    <FlowParts {...{flow:'flow1'}}></FlowParts>
                        <div className="select_content">
                            <QuestionA3Parts></QuestionA3Parts>
                            <ButtonTemplate>
                                <ButtonParts {...{type:'yes', 
                                    onClickEvent:()=>{
                                        questionTypeChage()
                                    }}}></ButtonParts>

                            <ButtonParts {...{type:'no', 
                                    onClickEvent:()=>{
                                        setQuestionCheck('no')
                                    }}}></ButtonParts>
                            </ButtonTemplate>
                        </div>
                    </>
                 }
                  {
                    questionCheck === 'no' &&
                    <>
                     <div className="select_content">
                        <QualificationNg></QualificationNg>
                        <ButtonTemplate>
                            <ButtonParts {...{type:'back', 
                                onClickEvent:()=>{
                                    setQuestionCheck(0)
                                }}}></ButtonParts>
                        </ButtonTemplate>
                     </div>
                    </>
                }
                 </>
            }
            {
                questionType === 1 &&
                <>
                <FlowParts {...{flow:'flow1'}}></FlowParts>
                {
                    questionCheck === 0 &&
                    <>
                        <div className="select_content">
                            <QuestionA1Parts></QuestionA1Parts>
                            <ButtonTemplate>
                                <ButtonParts {...{type:'yes', 
                                    onClickEvent:()=>{
                                        setQuestionCheck('yes')
                                    }}}></ButtonParts>

                            <ButtonParts {...{type:'no', 
                                    onClickEvent:()=>{
                                        questionTypeChage()
                                    }}}></ButtonParts>
                            </ButtonTemplate>
                        </div>
                    </>
                }
                {
                    questionCheck === 'yes' &&
                    <>
                        <div className="select_content">
                            <QuestionB1Parts></QuestionB1Parts>
                            <ButtonTemplate>
                                <ButtonParts {...{type:'yes', 
                                    onClickEvent:()=>{
                                        nextFlow()
                                    }}}></ButtonParts>
                                <ButtonParts {...{type:'back', 
                                    onClickEvent:()=>{
                                        setQuestionCheck(0)
                                    }}}></ButtonParts>
                            </ButtonTemplate>
                        </div>
                    </>
                }
                </>
            }
            {
                questionType === 2 &&
                <>
                <FlowParts {...{flow:'flow1'}}></FlowParts>
                {
                    questionCheck === 0 &&
                    <>
                        <QuestionA2Parts></QuestionA2Parts>
                        <div className="select_content">
                            <ButtonTemplate>
                                <ButtonParts {...{type:'yes', 
                                    onClickEvent:()=>{
                                        setQuestionCheck('yes')
                                    }}}></ButtonParts>
    
                            <ButtonParts {...{type:'no', 
                                    onClickEvent:()=>{
                                        questionTypeChage()
                                    }}}></ButtonParts>
                            </ButtonTemplate>
                        </div>
                    </>
                }
                {
                    questionCheck === 'yes' &&
                    <>
                    <div className="select_content">
                        <QuestionB2Parts></QuestionB2Parts>
                        <ButtonTemplate>
                            <ButtonParts {...{type:'yes', 
                                onClickEvent:()=>{
                                    nextFlow()
                                }}}></ButtonParts>
                            <ButtonParts {...{type:'back', 
                                onClickEvent:()=>{
                                    setQuestionCheck(0)
                                }}}></ButtonParts>
                        </ButtonTemplate>
                    </div>
                    </>
                }
                </>
            }
            {
                questionType === 3 &&
                <>
                <FlowParts {...{flow:'flow1'}}></FlowParts>
                {
                    questionCheck === 0 &&
                    <>
                    <div className="select_content">
                        <QuestionB3Parts></QuestionB3Parts>
                        <ButtonTemplate>
                            <ButtonParts {...{type:'yes', 
                                onClickEvent:()=>{
                                    nextFlow()
                                }}}></ButtonParts>
                            <ButtonParts {...{type:'back', 
                                onClickEvent:()=>{
                                    setQuestionType(1)
                                    setQuestionCheck(0)
                                }}}></ButtonParts>
                        </ButtonTemplate>
                    </div>
                    </>
                }
                
                </>
            }
        </div>
    )
}